export default __webpack_public_path__ + "static/media/contact-2k.17832e83.jpg";